/**
 * Created by anatoly on 28.02.2025
 */

const SwapHintView = function () {
    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on(SwapHintAlgorithm.type, this.show.bind(this));
};

SwapHintView.prototype.show = function (options) {
    this.hide();

    let cellA, cellB;
    let cells = [];
    if (options.shape) {
        cells = options.shape.cells;
    } else {
        cellA = options.start;
        cellB = Game.currentGame.field.cells[cellA.y + options.dir.row] && Game.currentGame.field.cells[cellA.y + options.dir.row][cellA.x + options.dir.col];
        if (!cellA || !cellB) {
            return;
        }
        cells.push(cellA);
        cells.push(cellB);
    }

    this.hintDelay = cleverapps.timeouts.setTimeout(() => {
        cells.forEach((cell) => {
            const currentCell = cell.innerCell || cell;
            currentCell.onAvailableMoveListener(options);
        });
    }, 2000);

    cleverapps.effects.fire("match3.move.available");

    this.cells = cells;
};

SwapHintView.prototype.hide = function () {
    if (!this.cells) {
        return;
    }

    if (this.hintDelay) {
        cleverapps.timeouts.clearTimeout(this.hintDelay);
        this.hintDelay = undefined;
    }

    this.cells.forEach((cell) => {
        const currentCell = cell.innerCell || cell;
        if (currentCell.alive) {
            currentCell.onStartMoveListener({ x: cell.x, y: cell.y }, { moveInterval: 0.1, easing: cc.easeOut(1) });
        }
    });

    this.cells = undefined;
};